var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"integrationZapier"}},[_c('iframe',{ref:"iframeRef",staticClass:"thin-scrollbar iframe-container",attrs:{"id":"iframeRef","src":"https://zapier.com/editor/sandbox/draft/1/setup","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }